export const RECORD_DRAFT_KEY = 'wj_record_draft_v1';
export const RECORD_DRAFT_RESUME_KEY = 'wj_resume_record_draft';
export const RECORD_DRAFT_EVENT = 'wj-record-draft-change';

export function getRecordDraft() {
    try {
        const raw = localStorage.getItem(RECORD_DRAFT_KEY);
        if (!raw) return null;
        const draft = JSON.parse(raw);
        return draft?.form?.sport ? draft : null;
    } catch {
        return null;
    }
}

export function saveRecordDraft(draft) {
    localStorage.setItem(RECORD_DRAFT_KEY, JSON.stringify({ ...draft, savedAt: new Date().toISOString() }));
    notifyRecordDraftChange();
}

export function clearRecordDraft() {
    localStorage.removeItem(RECORD_DRAFT_KEY);
    notifyRecordDraftChange();
}

export function notifyRecordDraftChange() {
    window.dispatchEvent(new Event(RECORD_DRAFT_EVENT));
}
